import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { TripActivityService } from '@app/trips/services/trip-activity.service';
import { FirebaseDataService } from '@app/shared/services/firebase-data.service';
import { NotificationObj } from '@app/shared/models/shared.model';
import { ModalController } from '@ionic/angular';
import { CommonService } from '@app/shared/services/common.service';
import { Notification, TripActivityModel } from '@app/trips/trips-tab/model/model.index';
import { FirebasePlaformKey, MessageConfig } from '@app/shared/constants/constant';
import { AboutUserComponent } from '@app/trips/trips-tab/trip-services/about-user/about-user.component';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';

@Component({
    selector: 'app-charter-notifications',
    templateUrl: './charter-notifications.page.html',
    styleUrls: ['./charter-notifications.page.scss'],
    standalone: false
})
export class CharterNotificationsPage implements OnInit {
  public slectedTripId: any;
  public pageType: string = 'charterInfo';
  public notificationArr: NotificationObj[] = [];
  public searchArr: NotificationObj[] = [];
  public messageConfig = MessageConfig;
  public subscription: Subscription = new Subscription();
  public isHomePage: boolean = false;

  @Input() public tripModel = new TripActivityModel();

  constructor(
    private tripActivityService: TripActivityService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private firebaseDataService: FirebaseDataService,
    private modalController: ModalController,
    public commonService: CommonService,
    private location: Location
  ) {
    this.activatedRoute.queryParamMap.subscribe(() => {
      const navigation = this.router.getCurrentNavigation();
      if (navigation && navigation.extras.state) {
        const params = navigation.extras.state;
        this.slectedTripId = params.tripID;
      }
    });
  }

  public ngOnInit() {
    this.tripActivityService.sendselectedTripTotalCountValue(this.slectedTripId);
    this.subscription = this.firebaseDataService.$NotificationsRef.subscribe(notifications => {
      if (notifications) {
        this.getNotificationInfo(notifications);
      }
    });
    this.NotificationInit();
  }

  public ionViewDidEnter() {
    this.firebaseDataService.markNotificationAsRead(this.slectedTripId);
  }

  public ionViewWillLeave() {}

  public ngOnDestroy() {
    this.firebaseDataService.CharterNotificationsUnread.next(null);
    this.firebaseDataService.$NotificationsRef.next(null);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public NotificationInit() {
    this.subscription = this.firebaseDataService.CharterNotificationsUnread.subscribe((res) => {
      if (res && this.pageType == 'allNotification') {
        this.getNotificationInfo(res);
      }
    });
  }

  public getNotificationInfo(ObjectData: any) {
    this.notificationArr = [];
    this.searchArr = [];
    const refData = [];

    if (ObjectData != null) {
      for (const key in ObjectData) {
        if (key) {
          refData.push(ObjectData[key]);
        }
      }
      refData.forEach(element => {
        this.searchArr.push(element);
        this.notificationArr.push(element);
      });

      this.notificationArr.sort((a, b) => {
        return new Date(b.senddate).getTime() - new Date(a.senddate).getTime();
      });
      this.searchArr.sort((a, b) => {
        return new Date(b.senddate).getTime() - new Date(a.senddate).getTime();
      });
    }
  }

  public hasTodayNotifications(): boolean {
    if (!this.notificationArr) return false;
    const today = new Date().toDateString();
    return this.notificationArr.some(notification =>
      new Date(notification.senddate).toDateString() === today
    );
  }

  public getTodayNotifications(): NotificationObj[] {
    if (!this.notificationArr) return [];
    const today = new Date().toDateString();
    return this.notificationArr.filter(notification =>
      new Date(notification.senddate).toDateString() === today
    );
  }

  public hasPreviousNotifications(): boolean {
    if (!this.notificationArr) return false;
    const today = new Date().toDateString();
    return this.notificationArr.some(notification =>
      new Date(notification.senddate).toDateString() !== today
    );
  }

  public getPreviousNotifications(): NotificationObj[] {
    if (!this.notificationArr) return [];
    const today = new Date().toDateString();
    return this.notificationArr.filter(notification =>
      new Date(notification.senddate).toDateString() !== today
    );
  }

  public getNotificationTitle(notification: NotificationObj): string {
    if (notification.content.toLowerCase().includes('activated')) return 'Trip Activated';
    if (notification.content.toLowerCase().includes('completed')) return 'Trip Completed';
    if (notification.content.toLowerCase().includes('scheduled')) return 'Trip Scheduled';
    if (notification.content.toLowerCase().includes('delayed')) return 'Flight Delayed';
    if (notification.content.toLowerCase().includes('updated')) return 'Trip Updated';
    return 'Flight Update';
  }

  public getFlightRoute(notification: NotificationObj): string {
    if (notification.content.includes('VIDP-VOHS-VIDP')) return 'Delhi-Hyderabad-Delhi';
    if (notification.content.includes('Mumbai-Delhi')) return 'Mumbai-Delhi-Mumbai';
    if (notification.content.includes('Hyderabad-Delhi')) return 'Hyderabad-Delhi-Hyderabad';
    return 'Flight Route';
  }

  public getTripId(notification: NotificationObj): string {
    const match = notification.content.match(/Trip ID (\d+)/);
    return match ? match[1] : 'N/A';
  }

  public getAircraft(notification: NotificationObj): string {
    if (notification.content.includes('VT-CKP')) return 'VT-CKP';
    return 'Aircraft';
  }

  public getStatusClass(notification: NotificationObj): string {
    if (notification.content.toLowerCase().includes('activated')) return 'status-active';
    if (notification.content.toLowerCase().includes('completed')) return 'status-completed';
    if (notification.content.toLowerCase().includes('upcoming')) return 'status-upcoming';
    return 'status-default';
  }

  public getStatusText(notification: NotificationObj): string {
    if (notification.content.toLowerCase().includes('activated')) return 'Activated';
    if (notification.content.toLowerCase().includes('completed')) return 'Completed';
    if (notification.content.toLowerCase().includes('upcoming')) return 'Upcoming';
    return 'Scheduled';
  }

  public getIconClass(notification: NotificationObj): string {
    if (notification.content.toLowerCase().includes('activated')) return 'icon-container active-icon';
    if (notification.content.toLowerCase().includes('completed')) return 'icon-container completed-icon';
    return 'icon-container default-icon';
  }

  public getIconName(notification: NotificationObj): string {
    if (notification.content.toLowerCase().includes('activated')) return 'checkmark-circle-outline';
    if (notification.content.toLowerCase().includes('completed')) return 'flag-outline';
    if (notification.content.toLowerCase().includes('delayed')) return 'time-outline';
    return 'information-circle-outline';
  }

  public searchItem(ev: any) {
    const val = ev.target.value;
    if (val && val != '') {
      this.notificationArr = this.searchArr.filter((element: NotificationObj) => {
        return (element.content.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    } else {
      this.notificationArr = this.searchArr;
    }
  }

  public async vendorInfo(service: Notification) {
    if (service.Sendertype == "client") {
      if (service.sender == this.commonService.uid || service.sender == FirebasePlaformKey.key) {
        return false;
      }
      const popover = await this.modalController.create({
        component: AboutUserComponent,
        componentProps: {
          VendorId: this.tripModel.activityData.clientId,
          Type: service.Sendertype == "client" ? "Operator" : service.Sendertype,
          Logo: service.logo,
          firebaseuid: service.sender,
        },
      });
      await popover.present();
    }
  }

  public goBack() {
    this.location.back();
  }
}